import React from 'react';

function RenderCustomCounselingEight({ data, id }) {
  return (
    <div className="smart-tag-sec content-line-break">
      <div className="smart-tag-bdy" id={'sectionVal_' + id}>
        {data?.renderCustomCounselingEightData?.map((item, i) => (
          <div key={i} className="smart-tag-bdy-rw width100 recrd-nt-rw">
            {item[2]?.length > 0 && (
              <div className="frst-sec-lbl recrd-nt-prnt-hdng">{item[1]}</div>
            )}
            {item[2] &&
              item[2]?.map((subItem, j) => (
                <div key={j} className="smart-tag-bdy-rw">
                  <span className="frst-sec-lbl">{subItem?.label}:</span>
                  <span className="frst-sec-val sec-colr">
                    {subItem?.content}
                  </span>
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default RenderCustomCounselingEight;
